import { render } from "./JoinProjectConfirmationView.vue?vue&type=template&id=26639565"
import script from "./JoinProjectConfirmationView.vue?vue&type=script&lang=js"
export * from "./JoinProjectConfirmationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__